import { Shield } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-12 border-t border-border">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <div className="flex items-center gap-2">
            <Shield className="w-6 h-6 text-primary" />
            <span className="font-mono text-sm">
              <span className="text-primary">tunchi</span>
              <span className="text-muted-foreground">.pro</span>
            </span>
          </div>

          {/* Copyright */}
          <p className="text-sm text-muted-foreground font-mono">
            © {currentYear} Omar Totangy. All systems secured.
          </p>

          {/* Status indicator */}
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-primary" />
            </span>
            <span className="font-mono">Available for projects</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
